import Building from '~/client/src/shared/models/LocationObjects/Building'
import Level from '~/client/src/shared/models/LocationObjects/Level'
import { sortLevels } from '~/client/src/shared/utils/sortingFunctions'

/**
 * The levels an attribute (equipment / vertical object) can access, derived from
 * its parent building. Shared by the domain stores' save path and the resource
 * edit save path so parent changes recompute accessibility consistently.
 *
 * `currentAccessibleLevels` narrows the result to the previously-selected subset
 * when those levels still belong to the (new) building; otherwise all of the
 * building's levels are returned.
 */
export function computeAccessibleLevels(
  parentId: string | undefined | null,
  buildings: Map<string, Building>,
  levels: Map<string, Level>,
  currentAccessibleLevels?: string[],
): string[] {
  const building = parentId ? buildings.get(parentId) : undefined

  let list = Array.from(levels.values()).filter(
    l => !l.isDeleted && l.isParent(building),
  )

  if (currentAccessibleLevels?.length) {
    const filtered = list.filter(l => currentAccessibleLevels.includes(l.id))
    list = filtered.length ? filtered : list
  }

  return (
    building?.sortLevelsByCustomOrder(list) ||
    list.sort((a, b) => sortLevels(b, a))
  ).map(l => l.id)
}
